module.exports = __webpack_public_path__ + "img/placeholder_header_1.7a516a19.jpg";